const SHOW_MESSAGES = 'SHOW_MESSAGES';
const CLOSE_MESSAGE = 'CLOSE_MESSAGE';

export {
  SHOW_MESSAGES,
  CLOSE_MESSAGE,
};
